module.exports = __webpack_public_path__ + "static/media/spider.6e87e29b.svg";